import React, { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { Today } from "../../utils/strings";
import { addLeave, getTeamMates } from "../../utils/helper";
import { alertSuccess, alertError } from "../../utils/alerts";
import moment from "moment";

const INIT_STATE = {
    relief_officer: "",
    leave_type: "",
    start_date: "",
    end_date: "",
    year: "2024",
    no_of_days: 0,
};

export default function ApplyForLeave() {
    const [state, setState] = useState(INIT_STATE);
    const [loading, setLoading] = useState(false);
    const [date] = useState(Today());
    const [mates, setMates] = useState(null);
    
    useEffect(() => {
        setState((prev) => ({
            ...prev,
            start_date: (date && date) || "",
            end_date: (date && date) || "",
        }));
    }, [date]); 

    const getBusinessDaysCallback = useCallback(() => {
        if(state.start_date !=="" && state.end_date !==""){
            const start = moment(state.start_date);
            const end = moment(state.end_date);
            const daysDiff = end.diff(start, 'days');
            const weekendCount = Math.floor((start.day() + daysDiff) / 7) * 2;
            const businessDays = daysDiff - weekendCount;
            if (businessDays > 0) {
                setState(prev => ({
                    ...prev,
                    no_of_days: businessDays,
                }));
            }
        }
    }, [state.start_date, state.end_date]);

    useEffect(() => {
        if(state.start_date !=="" && state.end_date !==""){
            getBusinessDaysCallback();
        }
    }, [getBusinessDaysCallback, state.start_date, state.end_date]);

    useEffect(() => {
        getTeamMates()
            .then((res) => {
                setMates(res.data.data);
            })
            .catch((err) => {
                console.log(err?.response?.data?.error)
            });
    }, []);

    const handleChange = (e) => {
        e.persist();
        setState((prev) => ({
            ...prev,
            [e.target.name]: e.target.value,
        }));
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (window.confirm("Note: Are you sure you want to proceed? Click OK to proceed.")) {
            const data = {...state };
            if((data.no_of_days > 0) && data.leave_type && data.relief_officer){
                setLoading(true);
                addLeave(data)
                .then((res) => {
                    if(res.data.success){
                        alertSuccess(res.data.message)
                    } else {
                        alertError(res.data.message)
                    }
                    setLoading(false);
                })
                .catch((err) => {
                    console.log(err.response)
                    alertError(err.response?.data?.error);
                    setLoading(false);
                });
            };
        } else {alert("Leave submission was canceled!");}
    }
    
    return (
        <>
            <div className="spur-card-menu"><Link to="/leave/requests" className="pull-right btn topbtn btn-primary">LEAVE REQUESTS</Link></div>
            
            <h1 className="dash-title">Leave Requests</h1>

            <div className="row dash-row">
                <div className="col-md-12 col-sm-12 col-12">
                    <div className="card spur-card" style={{marginTop: 5}}>
                        <div className="card-header">
                            <div className="spur-card-title">Apply for Leave</div>
                        </div>
                        <div className="card-body">
                            <form method="post" encType="multipart/form-data" onSubmit={handleSubmit}>
                                <div className="row">
                                    <div className="col-md-3 col-sm-6 col-xs-6 form-group">
                                        <label className="control-label">Leave Type: <span>*</span></label>
                                        <select className="form-control form-select" name="leave_type" id="leave_type" required 
                                            onChange={handleChange} defaultChecked={state.leave_type || ""}>
                                            <option value="">Select Leave Type</option>
                                            <option value="Annual Leave">Annual Leave</option>
                                            <option value="Sick Leave">Sick Leave</option>
                                            <option value="Compassionate Leave">Compassionate Leave</option>
                                            <option value="Maternity Leave">Maternity Leave</option>
                                            <option value="Paternity Leave">Paternity Leave</option>
                                            <option value="Others">Others</option>
                                        </select>
                                    </div>
                                    <div className="col-md-3 col-sm-6 col-xs-6 form-group">
                                        <label className="control-label">Start Date: <span>*</span></label>
                                        <input name="start_date" type="date" placeholder="Start Date" className="form-control" required 
                                            onChange={handleChange} defaultValue={state.start_date} />
                                    </div>
                                    <div className="col-md-3 col-sm-6 col-xs-6 form-group">
                                        <label className="control-label">End Date: <span>*</span></label>
                                        <input name="end_date" type="date" placeholder="End Date" className="form-control" required 
                                            onChange={handleChange} defaultValue={state.end_date} />
                                    </div>
                                    <div className="col-md-3 col-sm-6 col-xs-6 form-group">
                                        <label className="control-label">Handing Over To: <span>*</span></label>
                                        <select className="form-control form-select" name="relief_officer" id="relief_officer" required 
                                            onChange={handleChange}>
                                            <option value=''>Select Relief Officer</option>
                                            {mates && mates.map((mate, i) => (
                                                <option key={i} value={mate._id}>{mate.first_name} {mate.last_name}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                                <div className="row form-group">
                                    <div className="col-md-12 col-sm-12">
                                        <button 
                                            type="submit" 
                                            className="btn btn-primary" 
                                            disabled={loading || (state.no_of_days === 0) || (state.relief_officer === "")}
                                        >
                                                SUBMIT REQUEST
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
